import React, { useState, useEffect } from 'react';
import './../common/button.css';
import './header.css';
import './../common/popup.css';

import Navitem from '../common/headeritem';

import logo from '../../assets/logo1.svg';
import burger from './../../assets/burger.svg';
import close from './../../assets/close.svg';
import lang from './../../assets/lang.svg';

import { useTranslation } from 'react-i18next';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const { t, i18n } = useTranslation();

    useEffect(() => {
        const savedLang = localStorage.getItem("lang") || "en";
        i18n.changeLanguage(savedLang);
    }, []);

    useEffect(() => {
        document.body.dir = i18n.language === "ar" ? "rtl" : "ltr";
    }, [i18n.language]);

    const openPopup = () => setIsOpen(true);
    const closePopup = () => setIsOpen(false);

    const changeLanguage = () => {
        const newLang = i18n.language === "en" ? "ar" : "en";
        i18n.changeLanguage(newLang);
        localStorage.setItem("lang", newLang);
    };

    return (
        <>
            <div className="headerCont">
                <header>
                    {/* LOGO */}
                    <div className="logo">
                        <img src={logo} alt="logo" />
                    </div>

                    {/* DESKTOP NAV */}
                    <ul>
                        <li><Navitem title={t('navbar.categories')} link="#categories" /></li>
                        <li><Navitem title={t('navbar.about')} link="#about" /></li>
                        <li><Navitem title={t('navbar.events')} link="#events" /></li>
                        <li><Navitem title={t('navbar.featured')} link="#featured" /></li>
                        <li><Navitem title={t('navbar.feedback')} link="#feedback" /></li>
                        <li><Navitem title={t('navbar.book')} link="#book" /></li>
                        <li><Navitem title={t('navbar.subscribe')} link="#subscribe" /></li>
                    </ul>

                    {/* ACTION BUTTONS */}
                    <div className="btnFlex">
                        {/* LANGUAGE SWITCH */}
                        <button className="btn3" onClick={changeLanguage}>
                            <img src={lang} alt="lang" />
                        </button>

                        {/* BURGER MENU */}
                        <button className="btn3 burgermenu" onClick={openPopup}>
                            <img src={burger} alt="menu" />
                        </button>
                    </div>
                </header>
            </div>

            {/* MOBILE POPUP */}
            <div className={`popUp ${isOpen ? "show" : "hide"}`}>
                <div>
                    <ul className="burgernav">
                        <Navitem title={t('navbar.categories')} link="#categories" />
                        <Navitem title={t('navbar.about')} link="#about" />
                        <Navitem title={t('navbar.events')} link="#events" />
                        <Navitem title={t('navbar.featured')} link="#featured" />
                        <Navitem title={t('navbar.feedback')} link="#feedback" />
                        <Navitem title={t('navbar.book')} link="#book" />
                        <Navitem title={t('navbar.subscribe')} link="#subscribe" />
                    </ul>

                    {/* CLOSE BUTTON */}
                    <button className="btn3 closed" onClick={closePopup}>
                        <img src={close} alt="close" />
                    </button>
                </div>
            </div>
        </>
    );
};

export default Navbar;